<mat-card class="kpi-card" [style.border-left-color]="color">
  <mat-card-content>
    <div class="kpi-header">
      <mat-icon [style.color]="color">{{ icon }}</mat-icon>
      <span class="kpi-title">{{ title }}</span>
    </div>
    <div class="kpi-value">{{ value }}</div>
    <div class="kpi-footer">
      <span class="kpi-subtitle" *ngIf="subtitle">{{ subtitle }}</span>
      <span class="kpi-trend" [ngClass]="trendClass" *ngIf="trend !== 0">
        <mat-icon class="trend-icon">{{ trendIcon }}</mat-icon>
        {{ formattedTrend }}
      </span>
    </div>
  </mat-card-content>
</mat-card>
